// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2X82z","cookiesSettings":"Footer_cookiesSettings__ipt3U","copyright":"Footer_copyright__2ncd8"};